import _ from 'lodash';
import $ from 'jquery';
import angular from 'angular';
import template from './template.html';
import Logger from '../logger';
import searchItemsPriority, { preferredPrioritySupportCriterias } from '../../constants/searchItemsPriority';

export class LocationDynamicCriteriaComponent {
    /* @ngInject */
    constructor(dynamicDataService, staticDataService, $timeout, RouteService, searchCacheService, utils, $element, $scope) {
        this.utils = utils;
        this.$scope = $scope;
        this.$scope.searchItemsPriority = searchItemsPriority;
        this.$scope.preferredPrioritySupportCriterias = preferredPrioritySupportCriterias;
        this.searchCacheService = searchCacheService;
        this.dynamicDataService = dynamicDataService;
        const ctrl = this;

        ctrl.init = function () {
            ctrl.filteredValuesCount = RouteService.getSystemPreference('filteredValuesCount');
            ctrl.filteredValuesDynamicDelay = RouteService.getSystemPreference('filteredValuesDynamicDelay');
            ctrl.MaxLocationsCountPerPosition = RouteService.getSystemPreference('MaxLocationsCountPerPosition');
            ctrl.mandatoryValues = [
                {
                    value: 'optional',
                    text: 'NORMAL',
                },
                {
                    value: 'preferred',
                    text: 'PREFERRED_PRIORITY_LABEL',
                },
                {
                    value: 'mandatory',
                    text: 'MANDATORY_MINUS',
                },
                {
                    value: 'filter',
                    text: 'MANDATORY',
                },
            ];
        };

        ctrl.modifyValue = function (data) {
            ctrl.showAdd = true;
            ctrl.filterValues = data.text || data.value;

            if (data.additional) {
                ctrl.subCriteriaValue = {
                    id: data.additional.uid,
                    text: data.additional.value,
                };
            }
        };

        ctrl.goToBottom = function () {
            if ($element[0].getBoundingClientRect().bottom > document.documentElement.clientHeight) {
                const scrollTop = $(window)
                    .scrollTop();
                $(window)
                    .scrollTop(($element[0].getBoundingClientRect().bottom - document.documentElement.clientHeight)
                        + scrollTop + 20);
            }
        };

        ctrl.getSubCriteriaData = async function () {
            if (ctrl.data.subCriteria !== null) {
                return staticDataService.getStaticData(ctrl.data.subCriteria.lookupData, (data) => {
                    ctrl.dynamicSubCriteriaData = data;

                    if (data) {
                        ctrl.data.selected = (ctrl.data.selected || []).map((item) => {
                            const additionalId = _.get(item, 'additional.uid');
                            const currentAdditionalValue = _.get(item, 'additional.value');
                            const additionalValue = data.find(({ id }) => id === additionalId);

                            if (additionalValue && !currentAdditionalValue) {
                                return {
                                    ...item,
                                    additional: {
                                        ...item.additional,
                                        ...additionalValue,
                                    },
                                };
                            }

                            return item;
                        });
                    }
                });
            }

            return Promise.resolve();
        };

        ctrl.subCriteriaChosen = function (value, init) {
            if (init && ctrl.dynamicSubCriteriaData) {
                const defaultSubCriteria = _.find(ctrl.dynamicSubCriteriaData, { isDefault: true });
                if (defaultSubCriteria) {
                    ctrl.subCriteriaValue = defaultSubCriteria;
                } else {
                    ctrl.subCriteriaValue = value;
                }
                ctrl.showSubCriteria = false;
                return;
            }
            ctrl.subCriteriaValue = value;
            ctrl.showSubCriteria = false;
            if (ctrl.inputReadyOnly && !init) {
                if (ctrl.data.selected.length > 0) {
                    ctrl.filterValueChosen(ctrl.data.selected[0]);
                } else {
                    ctrl.filterValueChosen(ctrl.originalValue);
                }
            }
        };

        ctrl.closeDynamic = function () {
            ctrl.showAdd = false;
            ctrl.showDropDown = false;
        };

        ctrl.removeValue = function (index) {
            ctrl.data.selected.splice(index, 1);
            this.canAdd = this.canAddMore();

            ctrl.requiredIndexes.splice(index, 1);
            ctrl.onChange();
        };

        ctrl.checkFieldsSelected = function () {
            for (let i = 0; i < ctrl.allData.length; i++) {
                const element = ctrl.allData[i];
                if (element.selected && element.selected.length > 0) {
                    return true;
                }
                if (element.minSelected && element.minSelected.length > 0) {
                    return true;
                }
                if (element.maxSelected && element.maxSelected.length > 0) {
                    return true;
                }
            }
            return false;
        };

        ctrl.filterChanged = function (click) {
            if (click == true && ctrl.dynamicFilteredData && ctrl.dynamicFilteredData.resultListLength > 0) {
                ctrl.showDropDown = true;
                return;
            }
            if (ctrl.dynamicGetDataDelay) {
                $timeout.cancel(ctrl.dynamicGetDataDelay);
                ctrl.toggleDropdown(true);
            }
            if (ctrl.filterValues && ctrl.filterValues.length > 1
                || ctrl.checkFieldsSelected()) {
                ctrl.dynamicGetDataDelay = $timeout(() => {
                    const selected = [];
                    for (let i = 0; i < ctrl.allData.length; i++) {
                        const element = ctrl.allData[i];
                        if (element.selected && element.selected.length > 0) {
                            selected.push({
                                field: element.field,
                                items: element.selected,
                            });
                        }
                        if (element.minSelected && element.minSelected.length > 0) {
                            selected.push({
                                field: element.minField,
                                items: element.minSelected,
                            });
                        }
                        if (element.maxSelected && element.maxSelected.length > 0) {
                            selected.push({
                                field: element.maxField,
                                items: element.maxSelected,
                            });
                        }
                    }

                    const requestBody = {
                        currentField: {
                            field: ctrl.data.field,
                            type: 'Text',
                            value: ctrl.filterValues,
                            matchType: 'contains',
                        },
                        searchCountries: [
                            {
                                code: 'US',
                            },
                        ],
                        maxItems: ctrl.filteredValuesCount,
                        searchLanguages: [
                            {
                                code: 'en-US',
                            },
                        ],
                        selected,
                    };

                    dynamicDataService.getFilteredSemiValues(requestBody)
                        .then((response) => {
                            ctrl.focusedOn = -1;
                            ctrl.dynamicFilteredData = {
                                field: _.get(response, 'result.results.field', 'locations'),
                                values: ctrl.filterLocations(ctrl.data.selected, _.get(response, 'result.results.values', [])),
                            };

                            if (ctrl.showAdd == true) {
                                ctrl.showDropDown = true;
                            }
                            $timeout(() => {
                                ctrl.goToBottom();
                            }, 200);
                        })
                        .catch((error) => Logger.error(error));
                }, ctrl.filteredValuesDynamicDelay, false);
            }
        };

        ctrl.toggleDropdown = (forceClose) => {
            if (forceClose) {
                ctrl.showDropDown = false;
            }

            ctrl.showDropDown = !ctrl.showDropDown;
        };

        ctrl.showAddButton = () => !ctrl.disable && ctrl.canAdd;

        ctrl.canAddMore = () => this.data.selected.length < this.MaxLocationsCountPerPosition;

        ctrl.init();
    }

    filterLocations(selectedCriteriaItems, fetchLocations) {
        const selectedCriteriaItemsByUid = _.keyBy(selectedCriteriaItems, 'uid');
        const hasZeroUid = selectedCriteriaItems.some((selectedCriteria) => selectedCriteria.uid == 0);
        return fetchLocations.filter((loc) => {
            if (hasZeroUid) {
                return !selectedCriteriaItemsByUid[loc.id] && selectedCriteriaItemsByUid[0].value !== loc.value;
            }

            return !selectedCriteriaItemsByUid[loc.id];
        });
    }

    setRequiredSubCriteria(idx, value) {
        this.mandatoryPopUpView = -1;
        this.data.selected[idx].required = value.required;

        const index = _.findIndex(this.mandatoryValues, { value: this.data.selected[idx].required });
        if (this.requiredIndexes.length === 0) {
            if (index >= 0) {
                const items = this.data.selected;
                for (let i = 0; i < items.length; i++) {
                    const importantIdx = _.findIndex(
                        this.mandatoryValues,
                        { value: this.data.selected[i].required },
                    );

                    this.requiredIndexes.push({
                        requiredValue: importantIdx,
                    });
                }

                this.requiredIndexes[idx].requiredValue = index;
            } else {
                this.requiredIndexes.push({
                    requiredValue: 0,
                });
            }
        } else if (index >= 0) {
            if (this.requiredIndexes[idx]) {
                this.requiredIndexes[idx].requiredValue = index;
            } else {
                this.requiredIndexes.push({
                    requiredValue: index,
                });
            }
        } else if (this.requiredIndexes[idx]) {
            this.requiredIndexes[idx].requiredValue = 0;
        } else {
            this.requiredIndexes.push({
                requiredValue: index,
            });
        }
        const subCriterita = _.find(this.dynamicSubCriteriaData, { text: value.additional });
        if (subCriterita) {
            this.subCriteriaValue = subCriterita;
            this.data.selected[idx].additional = {
                uid: this.subCriteriaValue.id,
                value: this.subCriteriaValue.text,
            };
            delete this.data.selected[idx].status;
        }
    }

    async initData() {
        this.showAdd = false;
        this.showDropDown = false;
        this.showSubCriteria = false;
        this.showInputLocation = false;
        this.requiredIndexes = [];

        this.canAdd = this.canAddMore();

        await Promise.all(
            (this.data.selected || []).map((selected) => this.dynamicDataService.getNationwideLocations(selected.uid)
                .then(({ result }) => {
                    selected.hideSubCriteriaData = result && result.length;
                    return selected;
                })),
        );

        for (let i = 0; i < this.data.selected.length; i++) {
            const selectedElement = this.data.selected[i];

            if (selectedElement.required === true) {
                selectedElement.required = 'mandatory';
            } else if (!selectedElement.required) {
                selectedElement.required = 'optional';
            } else if (selectedElement.required === 0 || selectedElement.required === false) {
                selectedElement.required = 'optional';
            }

            const index = _.findIndex(this.mandatoryValues, { value: selectedElement.required });

            if (index >= 0) {
                this.requiredIndexes.push({
                    requiredValue: index,
                });
            } else {
                this.requiredIndexes.push({
                    requiredValue: 0,
                });
            }
        }

        await this.getSubCriteriaData();

        this.hasPreferred = preferredPrioritySupportCriterias.includes(this.data.field);
    }

    filterValueChosen(value) {
        if (value.id) {
            value.id = value.id.toString();
        }
        const selected = {
            uid: value.id || '0',
            value: value.value || value.text,
            text: value.text,
            required: 'filter',
        };

        if (value.isNationwide) {
            const subCriteria = _.find(this.dynamicSubCriteriaData, { id: value.radius });
            selected.hideSubCriteriaData = true;
            if (subCriteria) {
                selected.additional = {
                    uid: subCriteria.id,
                    value: subCriteria.text,
                };
            }
        } else if (this.data.subCriteria !== null && this.subCriteriaValue) {
            selected.additional = {
                uid: this.subCriteriaValue.id,
                value: this.subCriteriaValue.text,
            };
        }

        if (!_.find(this.data.selected, { value: selected.value })) {
            (this.onBeforeValueAdded() || (() => {}))(selected);
            this.data.selected.push(selected);

            const mandatoryIndex = _.findIndex(this.mandatoryValues, { value: selected.required });

            this.requiredIndexes.push({
                requiredValue: mandatoryIndex,
            });
        }

        this.filterChanged();
        this.toggleDropdown(true);
        this.showAdd = false;
        this.showInputLocation = false;
        this.filterValues = '';
        this.onChange();
    }

    setPopupView(value) {
        this.mandatoryPopUpView = value;
    }

    saveChanges(idx, value) {
        this.mandatoryPopUpView = -1;

        const newPriorityValue = value.required;
        if (newPriorityValue === 'excluded') {
            this.data.selected[idx].required = 'filter';
            _.set(this.data, `selected[${idx}].additional.exclude`, true);
        } else {
            delete this.data.selected[idx].additional.exclude;
            this.data.selected[idx].required = newPriorityValue;
        }

        const index = _.findIndex(this.mandatoryValues, { value: this.data.selected[idx].required });

        if (this.requiredIndexes.length === 0) {
            if (index >= 0) {
                const items = this.data.selected;
                for (let i = 0; i < items.length; i++) {
                    const importantIdx = _.findIndex(
                        this.mandatoryValues,
                        { value: this.data.selected[i].required },
                    );

                    this.requiredIndexes.push({
                        requiredValue: importantIdx,
                    });
                }

                this.requiredIndexes[idx].requiredValue = index;
            } else {
                this.requiredIndexes.push({
                    requiredValue: 0,
                });
            }
        } else if (index >= 0) {
            if (this.requiredIndexes[idx]) {
                this.requiredIndexes[idx].requiredValue = index;
            } else {
                this.requiredIndexes.push({
                    requiredValue: index,
                });
            }
        } else if (this.requiredIndexes[idx]) {
            this.requiredIndexes[idx].requiredValue = 0;
        } else {
            this.requiredIndexes.push({
                requiredValue: index,
            });
        }

        const subCriteria = _.find(this.dynamicSubCriteriaData, { id: _.toNumber(value.additional?.uid) });

        if (subCriteria) {
            this.subCriteriaValue = subCriteria;
            _.set(this, `data.selected[${idx}].additional.uid`, this.subCriteriaValue.id);
            _.set(this, `data.selected[${idx}].additional.value`, this.subCriteriaValue.text);
            delete this.data.selected[idx].status;
        }
    }

    setPopupCriteriaIndex(criteriaIndex) {
        this.mandatoryPopUpView = criteriaIndex;
    }

    closePopup() {
        this.mandatoryPopUpView = -1;
    }
}

export const LocationDynamicCriteriaComponentConfiguration = {
    bindings: {
        data: '=',
        lastSearch: '=',
        allData: '=',
        disable: '<',
        createJob: '=',
        doNotHideDropDownAfterSelect: '=',
        onChange: '&',
        onBeforeValueAdded: '&',
    },
    controller: LocationDynamicCriteriaComponent,
    template,
    controllerAs: 'ctrl',
};

angular
    .module('TALENYA-FE')
    .component('locationDynamicCriteriaComponent', LocationDynamicCriteriaComponentConfiguration);
